
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";

interface EmptyTableRowProps {
  colSpan: number;
  message: string;
}

const EmptyTableRow: React.FC<EmptyTableRowProps> = ({
  colSpan,
  message
}) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="h-24 text-center">
        {message}
      </TableCell>
    </TableRow>
  );
};

export default EmptyTableRow;
